// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cziz5","controls":"styles_controls__308HR","charLimit":"styles_charLimit__75umA","input":"styles_input__3ECG7","send":"styles_send__XRW7F"};